import { render } from "./NoTradeReportingView.vue?vue&type=template&id=4af09738"
import script from "./NoTradeReportingView.vue?vue&type=script&lang=js"
export * from "./NoTradeReportingView.vue?vue&type=script&lang=js"

import "./NoTradeReportingView.vue?vue&type=style&index=0&id=4af09738&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__